// extracted by mini-css-extract-plugin
export var sbShowMain = "video-module--sb-show-main--1Nq0T";
export var laptop = "video-module--laptop--2thMs";
export var playButton = "video-module--playButton--2XzWv";
export var laptopImage = "video-module--laptopImage--16f9h";
export var preview = "video-module--preview--2pKHo";
export var player = "video-module--player--3aNeq";